/**
 * True for the PUBLIC Forms pages a visitor opens with no login:
 *   /forms/:clubSlug, /forms/:clubSlug/:formSlug, /forms/r/:ref
 * False for the admin pages /forms and /forms/edit/:formId.
 *
 * index.tsx and App.tsx use it to skip admin-only work on those pages
 * (the calendar socket, the support chat widget).
 */
export const isPublicFormsPath = (pathname: string): boolean => /^\/forms\/(?!edit(\/|$))[^/]+/.test(String(pathname || ""));
